export const EditIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.16211 18.3457L1.41406 19.3574C1.22266 19.4303 1.04948 19.3893 0.894531 19.2344C0.739583 19.0703 0.703125 18.8926 0.785156 18.7012L1.82422 16.0078L14.0059 3.82617L16.3438 6.16406L4.16211 18.3457ZM17.4922 5.04297L15.1406 2.70508L16.4121 1.44727C16.722 1.13737 17.0456 0.973307 17.3828 0.955078C17.7292 0.927734 18.0482 1.0599 18.3398 1.35156L18.8457 1.87109C19.1374 2.16276 19.2741 2.47721 19.2559 2.81445C19.2376 3.14258 19.0736 3.46615 18.7637 3.78516L17.4922 5.04297Z"
      fill="currentColor"
    />
  </svg>
);
